export const isDeviceIOS = () => {
  return /(iPad|iPhone|iPod)/g.test(window.navigator.userAgent);
};
